import { render, staticRenderFns } from "./WorkflowInformation.vue?vue&type=template&id=1527c086&scoped=true"
import script from "./WorkflowInformation.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkflowInformation.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WorkflowInformation.vue?vue&type=style&index=0&id=1527c086&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1527c086",
  null
  
)

export default component.exports